import { FC } from "react";
import { Snackbar, Alert } from "@mui/material";

interface Props {
  open: boolean;
  message: any;
  type?: "error" | "success";
  style?: any;
  onClose: () => void;
}

const autoHideDuration = 3000

const NoticeBanner: FC<Props> = ({
  open,
  message,
  type = "error",
  style,
  onClose,
}) => {

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      sx={style ?? styles.noticeBanner}
      onClose={() => onClose()}
    >
      <Alert
        severity={type}
        sx={styles.notice}
        onClose={onClose}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NoticeBanner;

const styles = {
  noticeBanner: {
    width: "100%",
    display: "block",
    position: "initial",
  },

  notice: {
    width: "100%",
  },
}